// extracted by mini-css-extract-plugin
export default {"root":"CurrencyChargeNotice_root__dKwiT","line":"CurrencyChargeNotice_line__1ZZlc"};